import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

/* ---------------- FETCH AUDIT LOGS ---------------- */
export const fetchAuditLogs = createAsyncThunk(
  "audit/fetchAuditLogs",
  async ({ companyId, action, search, limit = 10, skip = 0 }, { rejectWithValue }) => {
    try {
      // Create a clean params object
      const params = { limit, skip };

      // Only add to params if they have a real value
      if (companyId) params.companyId = companyId;
      
      // CRITICAL: If action is "All", don't send the key at all
      if (action && action !== "All") {
        params.action = action;
      }

      if (search && search.trim() !== "") {
        params.search = search.trim();
      }

      const response = await axios.get(`${API_URL}/audit-logs`, { params });
      return response.data; 
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to fetch audit logs";
      return rejectWithValue(msg);
    }
  }
);

const auditLogsSlice = createSlice({
  name: "audit",
  initialState: {
    list: [],
    totalItems: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    clearAuditError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Correctly mapping the API response structure
        state.list = action.payload.data || [];
        state.totalItems = action.payload.total || 0;
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearAuditError } = auditLogsSlice.actions;
export default auditLogsSlice.reducer;